import type { ButtonHTMLAttributes, ReactNode } from 'react'
import styles from './Button.module.css'

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'brand'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: 'md' | 'sm'
  fullWidth?: boolean
  /** Показывает вращение и блокирует повторное нажатие. */
  loading?: boolean
  children: ReactNode
}

export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  disabled,
  className,
  children,
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = [
    styles.button,
    styles[variant],
    size === 'sm' && styles.sm,
    fullWidth && styles.full,
    loading && styles.loading,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      // type по умолчанию 'button', а не 'submit': кнопка внутри формы
      // без явного типа отправляет её, и «Отмена» рядом с «Сохранить»
      // молча сохраняет.
      type={type}
      className={classes}
      // Пока идёт запрос, повторное нажатие создаёт вторую компанию или
      // второй платёж. Блокировка на время ожидания — не украшение.
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      <span className={loading ? styles.loadingLabel : undefined}>{children}</span>
      {loading && <span className={styles.spinner} aria-hidden="true" />}
    </button>
  )
}
